import { render } from "./CreateInventoryPage.vue?vue&type=template&id=76e1ee2e"
import script from "./CreateInventoryPage.vue?vue&type=script&lang=js"
export * from "./CreateInventoryPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__